import { safeDefine } from "../../registration/safe-define.js";
import { TimeSliderChaptersElement } from "../../ui/time-slider/chapters.js";
//#region src/define/ui/time-slider-chapters.ts
safeDefine(TimeSliderChaptersElement);
//#endregion

//# sourceMappingURL=time-slider-chapters.js.map